export function rmaForm() {
    const element = $(".rma-form-block .gfield_list_group_item");
    const addButton = $(".rma-form-block .add_list_item");
    const waitInterval = setInterval(elemExist, 500);
    function elemExist() {
        if(element.length) {
            clearInterval(waitInterval);
            addPlaceholders();
        }
    }

    function addPlaceholders() {
        element.each(function (index, el) {
            let placeholder = $(el).data("label");
            $(el).children("input").prop("placeholder", placeholder);
        });
    }

    $(document).on("click", addButton, function () {
        setTimeout(function () {
            addPlaceholders();
        },100);
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/rma-form.js